import request from "@/utils/request";

const BASE_URL = '/Evaluation';

export default {
    //获取列表
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    //获取信息
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: {id}
        })
    },
    //保存
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    //删除
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
}